import { useCreditLimitContext } from './useCreditLimitContext';
import { useCallback, useEffect, useRef, useState } from 'react';
import useScript, { Status } from '../../Business/hooks/useScript';

const useChargebeeCheckout = () => {
  const {
    chargebeeInstance,
    handlePlanUpgrade,
    selectedClientsAmount,
    setError,
    setPaymentLoading,
    setPaymentSuccess,
    setStep,
  } = useCreditLimitContext();

  const [chargebeeState, setChargebeeState] = useState(null);
  const iframeRef = useRef<HTMLIFrameElement>();
  const iframeWindow = iframeRef?.current?.contentWindow;
  const iframeDocument = iframeRef?.current?.contentDocument;

  const { status } = useScript(
    iframeDocument ? 'https://js.chargebee.com/v2/chargebee.js' : '',
    iframeDocument,
  );

  useEffect(() => {
    if (chargebeeState !== 'ready') {
      setChargebeeState(status);
    }
  }, [chargebeeState, status]);

  useEffect(() => {
    if (status === Status.ready) {
      // @ts-ignore
      chargebeeInstance.current = iframeWindow.Chargebee.init({
        site: window._env_.REACT_APP_CHARGEBEE_SITE,
        enableGATracking: true,
      });
      setChargebeeState('complete');
    }
    // @ts-ignore
  }, [status, iframeDocument, iframeWindow?.Chargebee]);

  const openChargebee = useCallback(async () => {
    const data = await handlePlanUpgrade(selectedClientsAmount / 10 - 1);
    chargebeeInstance.current.openCheckout({
      hostedPage: function () {
        return new Promise(function (resolve, reject) {
          const response = data?.metadata;
          return resolve(response);
        });
      },
      success: () => {
        setStep(3);
        setPaymentLoading(true);
        chargebeeInstance.current?.closeAll && chargebeeInstance.current?.closeAll();
        setPaymentSuccess(true);
      },
      error: () => {
        setStep(3);
        setError(true);
      },
    });
  }, [handlePlanUpgrade, selectedClientsAmount, setError, setStep]);

  useEffect(() => {
    if (chargebeeState === 'complete') {
      openChargebee();
    }
  }, [chargebeeState, openChargebee]);

  return {
    iframeRef,
  };
};

export default useChargebeeCheckout;
